// extracted by mini-css-extract-plugin
export default {"root":"CloseSharing__root--2_cg2","contrast":"CloseSharing__contrast--19Vqy","root_phone":"CloseSharing__root_phone--16_Tr"};